import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Shown in place of a property-scoped page (guests, bookings, reports, …)
 * when the signed-in user has no property yet. Rendered inside the app
 * Layout, so the full menu stays visible — the user can still reach their
 * profile and the create-property flow.
 */
export function NoPropertyState({
  title = 'No property yet',
  message = 'Create your property to start managing bookings, guests, rooms, and reports here.',
}: {
  title?: string;
  message?: string;
}) {
  return (
    <Card variant="outlined">
      <CardContent sx={{ py: { xs: 5, sm: 7 } }}>
        <Stack spacing={2.5} sx={{ alignItems: 'center', textAlign: 'center' }}>
          <Box
            sx={(theme) => ({
              width: 64,
              height: 64,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              bgcolor: alpha(theme.palette.primary.main, 0.12),
              color: 'primary.main',
            })}
          >
            <ApartmentIcon fontSize="large" />
          </Box>
          <Stack spacing={1} sx={{ alignItems: 'center' }}>
            <Typography variant="h2" sx={{ fontSize: { xs: '1.4rem', sm: '1.7rem' } }}>
              {title}
            </Typography>
            <Typography color="text.secondary" sx={{ maxWidth: 460 }}>
              {message}
            </Typography>
          </Stack>
          <Button
            component={RouterLink}
            to="/properties/new"
            variant="contained"
            size="large"
            startIcon={<AddBusinessIcon />}
          >
            Create your property
          </Button>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 460 }}>
            Been invited to an existing property? Open the invitation link from your email to join it.
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
